import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { ContaFinanceiraContext } from '../../context/ContaFinanceiraContext';
import { ContaFinanceiraType, CreateContaFinanceiraType, UpdateContaFinanceiraType } from '../../context/hooks/useContaFinanceira';
import useUser from '../../context/hooks/useUser';
import { PermissionModule, createPermissionChecker } from '../../types/permissions';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';

const ContaFinanceira = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listContaFinanceira, contaFinanceiraPageCount, getAllContaFinanceiraPaged, createContaFinanceira, updateContaFinanceira, deleteContaFinanceira } = useContext(ContaFinanceiraContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [newContaFinanceira, setNewContaFinanceira] = useState<CreateContaFinanceiraType>({
        name: '',
        openingBalance: 0,
        empresaId: objUserTk.EmpresaId,
    });
    const [editingContaFinanceira, setEditingContaFinanceira] = useState<UpdateContaFinanceiraType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const [filters, setFilters] = useState({
        name: '',
    });
    const [dataSearch, setDataSearch] = useState({ name: '' });

    useEffect(() => {
        setLoading(true);
        getAllContaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar contas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllContaFinanceiraPaged(value, pageSize, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllContaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ name: '' });
        setLoading(true);
        getAllContaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewContaFinanceira(prevContaFinanceira => ({
            ...prevContaFinanceira,
            [name]: value === '' ? null : value
        }));
    };

    const handleCreateContaFinanceira = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const payload = {
            ...newContaFinanceira,
            name: newContaFinanceira.name,
            openingBalance: Number(newContaFinanceira.openingBalance),
            empresaId: Number(newContaFinanceira.empresaId)
        };

        createContaFinanceira(payload)
            .then(createdContaFinanceira => {
                if (createdContaFinanceira) {
                    setCreateModalOpen(false);
                    setNewContaFinanceira({
                        name: '',
                        openingBalance: 0,
                        empresaId: objUserTk.EmpresaId,
                    });
                    getAllContaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId);
                } else {
                    console.error("Erro ao criar conta do finaneiro.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar conta do financeiro:", error);
            });
    };

    const handleEditContaFinanceira = (contaFinanceira: ContaFinanceiraType) => {
        setEditingContaFinanceira(contaFinanceira);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingContaFinanceira) {
            const updatedData = {
                ...editingContaFinanceira,
            };
            updateContaFinanceira(updatedData)
                .then(updatedContaFinanceira => {
                    if (updatedContaFinanceira) {
                        setEditModalOpen(false);
                        getAllContaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId);
                        setEditingContaFinanceira(null);
                    } else {
                        console.error("Erro ao atualizar conta.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar conta:", error);
                });
        }
    };

    const [confirmDeleteContaFinanceiraId, setConfirmDeleteContaFinanceiraId] = useState<number | null>(null);

    const handleDeleteContaFinanceira = (contaFinanceiraId: number) => {
        setConfirmDeleteContaFinanceiraId(contaFinanceiraId);
    };

    const executeDeleteContaFinanceira = () => {
        if (confirmDeleteContaFinanceiraId == null) return;
        deleteContaFinanceira(confirmDeleteContaFinanceiraId)
            .then(deletedContaFinanceira => {
                if (!deletedContaFinanceira) console.error("Erro ao excluir conta.");
                getAllContaFinanceiraPaged(1, pageSize, objUserTk.EmpresaId);
            })
            .catch(error => console.error("Erro ao excluir conta:", error));
        setConfirmDeleteContaFinanceiraId(null);
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Conta Financeira"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Buscar por nome da categoria"
                            value={dataSearch.name}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>

                    {hasPermission(PermissionModule.Financeiro, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar conta
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.Financeiro, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Nome</th>
                                        <th>Saldo de Abertura</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listContaFinanceira.map((contaFinanceira: ContaFinanceiraType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{contaFinanceira.id}</td>
                                                <td>{contaFinanceira.name}</td>
                                                <td>{contaFinanceira.openingBalance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>
                                                    {hasPermission(PermissionModule.Financeiro, 3) && (
                                                        <Button onClick={() => { handleEditContaFinanceira(contaFinanceira) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {hasPermission(PermissionModule.Financeiro, 4) && (
                                                        <Button onClick={() => handleDeleteContaFinanceira(contaFinanceira.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            {/* <div className="d-flex justify-content-end mt-3">
                                {contaFinanceiraPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={contaFinanceiraPageCount}
                                        />
                                    </div>
                                )}
                                {listContaFinanceira.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div> */}
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            const newSize = parseInt(e.target.value);
                                            setPageSize(newSize);
                                            getAllContaFinanceiraPaged(1, newSize, objUserTk.EmpresaId);
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {contaFinanceiraPageCount && (
                                    <div className="mt-2 mt-md-0">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={contaFinanceiraPageCount}
                                        />
                                    </div>
                                )}

                                {listContaFinanceira.length === 0 && (
                                    <div className="w-100 mt-3" style={{ color: "red" }}>
                                        NÃO FOI ENCONTRADO NENHUM REGISTRO
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as contas do financeiro.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => setCreateModalOpen(!createModalOpen)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar nova conta</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreateContaFinanceira}>
                        <Row>
                            <Col md='6'>
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="input-name">
                                        Nome da conta
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={newContaFinanceira.name}
                                        onChange={handleCreateInputChange}
                                        required
                                        placeholder="Ex: Conta Corrente, Bradesco, etc."
                                    />
                                </FormGroup>
                            </Col>
                            <Col md='6'>
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="input-openingBalance">
                                        Saldo de Abertura
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="openingBalance"
                                        id="openingBalance"
                                        value={newContaFinanceira.openingBalance}
                                        onChange={handleCreateInputChange}
                                        required
                                        placeholder="Ex: 1000.00"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Criar conta</Button>
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setCreateModalOpen(!createModalOpen)} size="m" className="ml-2">Cancelar</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" className="custom-modal-xl">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar informações da conta</ModalHeader>
                <ModalBody>
                    {editingContaFinanceira && (
                        <>
                            <Form onSubmit={handleEditSubmit}>
                                <Row>
                                    <Col md='6'>
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-name">Nome da conta</Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={editingContaFinanceira.name}
                                                onChange={e => setEditingContaFinanceira({ ...editingContaFinanceira, name: e.target.value })}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md='6'>
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-openingBalance">Saldo de Abertura</Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="openingBalance"
                                                id="openingBalance"
                                                value={editingContaFinanceira.openingBalance}
                                                onChange={e => setEditingContaFinanceira({ ...editingContaFinanceira, openingBalance: Number(e.target.value) })}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-end">
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setEditModalOpen(!editModalOpen)} size="m">Cancelar</Button>
                                </div>
                            </Form>
                        </>
                    )}
                </ModalBody>
            </Modal>

            <ModalConfirm
                openModal={confirmDeleteContaFinanceiraId !== null}
                closeModal={() => setConfirmDeleteContaFinanceiraId(null)}
                handleConfirm={executeDeleteContaFinanceira}
                title="Excluir conta"
                message="Tem certeza que deseja excluir esta conta? Esta ação não pode ser desfeita."
            />
        </>
    );
};

export default ContaFinanceira;